import {
  DEFAULT_LOADED_SUBJECT_MODULES,
  normalizeLoadedSubjectModules,
  type LoadedSubjectModules,
} from './subjectConfig';

export const LOADED_SUBJECT_MODULES_STORAGE_KEY = 'lec_loaded_subject_modules';

let memoryLoadedModules: LoadedSubjectModules = { ...DEFAULT_LOADED_SUBJECT_MODULES };

export function getMemoryLoadedSubjectModules(): LoadedSubjectModules {
  return memoryLoadedModules;
}

export function readPersistedLoadedSubjectModules(): LoadedSubjectModules {
  try {
    const saved = localStorage.getItem(LOADED_SUBJECT_MODULES_STORAGE_KEY);
    if (saved) {
      memoryLoadedModules = normalizeLoadedSubjectModules(JSON.parse(saved));
      return memoryLoadedModules;
    }
  } catch {
    // ignore storage errors
  }
  return memoryLoadedModules;
}

export function persistLoadedSubjectModules(loaded: LoadedSubjectModules): void {
  memoryLoadedModules = normalizeLoadedSubjectModules(loaded);
  try {
    localStorage.setItem(LOADED_SUBJECT_MODULES_STORAGE_KEY, JSON.stringify(memoryLoadedModules));
  } catch {
    // ignore storage errors
  }
}
